export default __webpack_public_path__ + "static/media/ilustracao-menina-segurando-livro.79c252b4.svg";